import { ReactElement, ReactNode } from 'react';
import type { TimerPreviewViewProps } from '@components/timerPreview';

const THUMBNAIL_PLACEHOLDERS = ['product-thumb-1', 'product-thumb-2', 'product-thumb-3'] as const;

export function PlacementBadge(): ReactElement {
	return (
		<div className='absolute bottom-0 left-1/2 grid h-8 w-8 -translate-x-1/2 translate-y-1/2 place-items-center rounded-full bg-[#F82D79] text-xl font-bold leading-none text-white'>
			+
		</div>
	);
}

export function ProductThumbnailPlaceholders({ className }: { className: string }): ReactElement {
	return (
		<div className='grid grid-cols-3 gap-3'>
			{THUMBNAIL_PLACEHOLDERS.map((id) => (
				<div key={id} className={`rounded bg-[#46506A] ${className}`} />
			))}
		</div>
	);
}

export default function ProductPageMock({ view, children }: TimerPreviewViewProps & { children: ReactNode }) {
	const isMobile = view === 'mobile';

	const gallery = (
		<div className={`flex min-w-0 flex-col gap-3 ${isMobile ? '' : 'sm:gap-4'}`}>
			<div className={`rounded-xl bg-[#46506A] ${isMobile ? 'h-[120px]' : 'h-[92px] sm:h-[366px] xl:h-[394px]'}`} />
			<ProductThumbnailPlaceholders className={isMobile ? 'h-10' : 'h-9 sm:h-[56px] xl:h-[64px]'} />
		</div>
	);

	const details = (
		<div className='flex min-w-0 flex-col gap-3 pt-1'>
			<div className='h-8 w-36 max-w-full rounded bg-[#46506A] xl:w-44' />
			<div className='h-4 rounded bg-[#46506A]' />
			<div className='h-4 rounded bg-[#46506A]' />
			<div className='relative overflow-visible'>{children}</div>
			<div className='grid grid-cols-2 gap-4 pt-2'>
				<div className='h-11 rounded bg-[#46506A] xl:h-12' />
				<div className='h-11 rounded bg-[#46506A] xl:h-12' />
			</div>
			<div className='h-3 rounded bg-[#46506A]' />
		</div>
	);

	if (isMobile) {
		return (
			<div className='flex min-h-full flex-col gap-5 p-4'>
				{details}
				{gallery}
			</div>
		);
	}

	return (
		<div className='grid min-h-full grid-cols-1 gap-4 p-6 sm:grid-cols-[1.05fr_0.95fr] sm:gap-6'>
			{gallery}
			{details}
		</div>
	);
}
